import { FC } from 'react';

import { Option } from '../../../../../MainSection/PractitionerProfile/MultipleSelect/MultipleSelect';
import ServiceByOpeartories from './ServiceByOperatories/ServiceByOperatories';
import { ServicesOperatories } from '../../PractitionerSchedule';

interface ServicesByOperatoriesProps {
  services: Option[];
  operatories: Option[];
  value: ServicesOperatories[];
  onChange: (...event: any[]) => void;
}

const ServicesByOperatories: FC<ServicesByOperatoriesProps> = ({
  services,
  operatories,
  value,
  onChange,
}) => {
  return (
    <ul className="flex flex-col px-2 py-2.1">
      {services.map((service) => (
        <ServiceByOpeartories
          key={service.value}
          service={service}
          operatories={operatories}
          value={value}
          onChange={onChange}
        />
      ))}
    </ul>
  );
};

export default ServicesByOperatories;
